import EmberRouter from '@ember/routing/router';
import config from 'pds-witsmlstudio-store/config/environment';
import { coreRoutes } from 'pds-witsmlstudio-core/routes';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('permissions');
  this.route('users');
});

Router.map(coreRoutes);
